module.exports = __webpack_public_path__ + "static/img/singleService-img.4f76b18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/keyFeaturesPhone/singleService-img.png
// module id = 5GK5
// module chunks = 0